import { Module, Mutation, VuexModule } from "vuex-module-decorators";
import Enviroment from "@/models/enviroment";
import {da} from "date-fns/locale";
import moment from "moment";

@Module({ namespaced: true })
class EnviromentModule extends VuexModule {
  constants: Enviroment | null = null;

  public get valuesInputDisabled(): boolean {
    const { constants } = this;

    const dates: number[] | null =
      constants &&
      ["ЮЛ_САЙТПОКАЗАНИЯОТ", "ЮЛ_САЙТПОКАЗАНИЯДО"].map(
        constantKey => constants[constantKey]
      );

    if (dates) {
      if(dates[0]>dates[1]){
        let current_month = new Date().getMonth() + 1

        let momentDates = []
        let dateNow = moment()
        momentDates[0] = moment(`${dates[0]}.${current_month}`, 'DD.MM')
        momentDates[1] = moment(`${dates[1]}.${current_month + 1}`, 'DD.MM')

        return !dateNow.isBetween(momentDates[0], momentDates[1])
      }

      const currentDate = new Date().getDate();

      return currentDate < dates[0] || currentDate > dates[1];
    }

    return false;
  }

  @Mutation
  setConstants(constants: Enviroment) {
    this.constants = constants;
  }
}

export default EnviromentModule;
